import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'María González',
    location: 'Villa Owner, Corralejo',
    rating: 5,
    text: 'Art Throng Home transformed our vacation rental completely. Their interior design team created a stunning space that our guests absolutely love, and their cleaning service keeps it pristine between bookings. Highly recommended!',
    verified: true,
  },
  {
    id: 2,
    name: 'Carlos Rodríguez',
    location: 'Homeowner, Caleta de Fuste',
    rating: 5,
    text: 'The monthly home refresh package has been a game-changer for our busy family. Professional, reliable, and always thorough. The team goes above and beyond every single time.',
    verified: true,
  },
  {
    id: 3,
    name: 'Laura Martínez',
    location: 'Property Manager, Costa Calma',
    rating: 5,
    text: 'Managing multiple properties is stressful, but Art Throng Home makes it easy. Their post-stay refresh service is incredibly efficient, and the quality is consistently excellent. Worth every euro!',
    verified: true,
  },
  {
    id: 4,
    name: 'Javier Hernández',
    location: 'Homeowner, Morro Jable',
    rating: 5,
    text: 'From renovation to regular maintenance, they handle everything with professionalism. The carpentry work they did in our home office is exceptional. True craftsmen!',
    verified: true,
  },
];

const beforeAfterImages = [
  {
    id: 1,
    image: 'https://public.readdy.ai/ai/img_res/7d9e39393aec592832e5e2680cbc4366.jpg',
    label: 'Living Room Transformation',
    description: 'Complete living room renovation featuring modern furniture, neutral color palette, and enhanced lighting. Transformed from a dated space into a contemporary sanctuary perfect for relaxation and entertaining.',
    beforeImage: 'https://readdy.ai/api/search-image?query=outdated%20old%20living%20room%20with%20worn%20furniture%20dark%20colors%20poor%20lighting%20cluttered%20space%20dated%20interior%20design%20needs%20renovation%20before%20transformation&width=800&height=600&seq=ba-before-001&orientation=landscape',
    afterImage: 'https://readdy.ai/api/search-image?query=stunning%20modern%20living%20room%20after%20renovation%20elegant%20neutral%20beige%20tones%20stylish%20contemporary%20furniture%20perfect%20lighting%20clean%20minimalist%20design%20professional%20interior%20transformation%20result&width=800&height=600&seq=ba-after-001&orientation=landscape',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=kitchen%20renovation%20before%20and%20after%20stunning%20transformation%20from%20old%20to%20modern%20sleek%20white%20cabinets%20marble%20countertops%20stainless%20appliances%20professional%20remodeling%20result%20clean%20minimalist%20design%20upgraded%20home%20interior&width=600&height=400&seq=ba-002&orientation=landscape',
    label: 'Kitchen Renovation',
    description: 'Modern kitchen remodel with sleek white cabinets, marble countertops, and stainless steel appliances. A complete transformation that combines functionality with elegant design.',
    beforeImage: 'https://readdy.ai/api/search-image?query=old%20outdated%20kitchen%20with%20worn%20cabinets%20dated%20appliances%20poor%20layout%20cluttered%20countertops%20needs%20complete%20renovation%20before%20transformation&width=800&height=600&seq=ba-before-002&orientation=landscape',
    afterImage: 'https://readdy.ai/api/search-image?query=beautiful%20modern%20kitchen%20after%20renovation%20white%20cabinets%20marble%20countertops%20stainless%20appliances%20clean%20design%20perfect%20lighting%20professional%20remodeling%20result&width=800&height=600&seq=ba-after-002&orientation=landscape',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=bedroom%20makeover%20before%20and%20after%20transformation%20cozy%20modern%20bedroom%20with%20neutral%20colors%20elegant%20bedding%20stylish%20decor%20improved%20lighting%20professional%20interior%20design%20result%20peaceful%20sanctuary%20space&width=600&height=400&seq=ba-003&orientation=landscape',
    label: 'Bedroom Makeover',
    description: 'Peaceful bedroom transformation with neutral tones, elegant bedding, and thoughtful decor. Created a serene sanctuary perfect for rest and relaxation.',
    beforeImage: 'https://readdy.ai/api/search-image?query=old%20bedroom%20before%20renovation%20outdated%20furniture%20poor%20lighting%20cluttered%20space%20needs%20makeover%20dated%20interior%20design&width=800&height=600&seq=ba-before-003&orientation=landscape',
    afterImage: 'https://readdy.ai/api/search-image?query=beautiful%20modern%20bedroom%20after%20makeover%20neutral%20colors%20elegant%20bedding%20stylish%20decor%20perfect%20lighting%20peaceful%20sanctuary%20professional%20interior%20design&width=800&height=600&seq=ba-after-003&orientation=landscape',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=bathroom%20renovation%20before%20and%20after%20luxury%20spa-like%20transformation%20modern%20fixtures%20elegant%20tiles%20sophisticated%20lighting%20clean%20minimalist%20design%20professional%20remodeling%20result%20upgraded%20home%20bathroom&width=600&height=400&seq=ba-004&orientation=landscape',
    label: 'Bathroom Upgrade',
    description: 'Luxury spa-like bathroom renovation with modern fixtures, elegant tiles, and sophisticated lighting. Transformed into a relaxing retreat with clean, minimalist design.',
    beforeImage: 'https://readdy.ai/api/search-image?query=old%20bathroom%20before%20renovation%20outdated%20fixtures%20worn%20tiles%20poor%20lighting%20needs%20complete%20upgrade%20dated%20design&width=800&height=600&seq=ba-before-004&orientation=landscape',
    afterImage: 'https://readdy.ai/api/search-image?query=luxury%20modern%20bathroom%20after%20renovation%20spa-like%20design%20elegant%20tiles%20modern%20fixtures%20perfect%20lighting%20clean%20minimalist%20professional%20remodeling%20result&width=800&height=600&seq=ba-after-004&orientation=landscape',
  },
];

export default function Testimonials() {
  const [selectedProject, setSelectedProject] = useState<typeof beforeAfterImages[0] | null>(null);

  return (
    <section id="testimonials" className="py-24 bg-[#2B2B2B]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <h2 className="font-serif text-4xl md:text-5xl text-white text-center mb-16">
          What Our Clients Say
        </h2>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl p-8 hover:shadow-2xl transition-shadow"
            >
              {/* Stars */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-700 leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-[#8B9B7E] rounded-full flex items-center justify-center text-white font-semibold">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <div className="flex items-center space-x-2">
                    <p className="font-semibold text-[#2B2B2B]">
                      {testimonial.name}
                    </p>
                    {testimonial.verified && (
                      <i className="ri-checkbox-circle-fill text-green-500 text-sm"></i>
                    )}
                  </div>
                  <p className="text-sm text-gray-500">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Before/After Gallery */}
        <div>
          <h3 className="font-serif text-3xl text-white text-center mb-12">
            Transformation Gallery
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {beforeAfterImages.map((item) => (
              <div
                key={item.id}
                onClick={() => setSelectedProject(item)}
                className="group relative h-64 rounded-2xl overflow-hidden cursor-pointer"
              >
                <img
                  src={item.image}
                  alt={item.label}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6">
                  <p className="text-white font-semibold text-lg">
                    {item.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal */}
      {selectedProject && (
        <div
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedProject(null)}
        >
          <div
            className="bg-white rounded-3xl max-w-5xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setSelectedProject(null)}
              className="absolute top-4 right-4 w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors shadow-lg z-10"
            >
              <i className="ri-close-line text-2xl text-gray-700"></i>
            </button>

            {/* Content */}
            <div className="p-8 md:p-12">
              <h3 className="font-serif text-3xl md:text-4xl text-[#2B2B2B] mb-4">
                {selectedProject.label}
              </h3>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                {selectedProject.description}
              </p>

              {/* Before & After Images */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div>
                  <p className="text-sm font-semibold text-gray-500 mb-3 uppercase tracking-wide">
                    Before
                  </p>
                  <div className="w-full h-80 rounded-2xl overflow-hidden">
                    <img
                      src={selectedProject.beforeImage}
                      alt={`${selectedProject.label} - Before`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-500 mb-3 uppercase tracking-wide">
                    After
                  </p>
                  <div className="w-full h-80 rounded-2xl overflow-hidden">
                    <img
                      src={selectedProject.afterImage}
                      alt={`${selectedProject.label} - After`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>

              {/* CTA Button */}
              <div className="text-center">
                <a
                  href="#booking"
                  onClick={() => setSelectedProject(null)}
                  className="inline-block bg-[#8B9B7E] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#7A8A6D] transition-colors whitespace-nowrap"
                >
                  Book Similar Service
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
